/*
 * Environment Detection Utility
 * Detects whether the add-in is running in Desktop Word (with Office SSO)
 * or Word Online without proper Microsoft account context
 */

export function isOfficeSSOAvailable() {
  if (typeof Office === 'undefined') {
    return false;
  }

  if (!Office.context || !Office.auth) {
    return false;
  }

  return true;
}

export function isWordOnline() {
  if (typeof Office === 'undefined' || !Office.context) {
    return false;
  }

  return Office.context.platform === Office.PlatformType.OfficeOnline;
}

export function getHostEnvironment() {
  if (typeof Office === 'undefined' || !Office.context) {
    return 'unknown';
  }

  const platform = Office.context.platform;

  switch (platform) {
    case Office.PlatformType.PC:
      return 'desktop-windows';
    case Office.PlatformType.Mac:
      return 'desktop-mac';
    case Office.PlatformType.OfficeOnline:
      return 'word-online';
    case Office.PlatformType.iOS:
      return 'mobile-ios';
    case Office.PlatformType.Android:
      return 'mobile-android';
    default:
      return 'unknown';
  }
}

export function shouldUseOfficeSSOFlow() {
  const env = getHostEnvironment();

  if (env === 'desktop-windows' || env === 'desktop-mac') {
    return isOfficeSSOAvailable();
  }

  return false;
}

export function shouldUseMSALFlow() {
  // Use direct MSAL for:
  // 1. Word Online (might not have MS account - users can access via guest/external sharing)
  // 2. When Office SSO is not available
  // 3. Mobile platforms (edge case)

  const env = getHostEnvironment();

  // Use MSAL for Word Online OR when Office SSO not available
  return env === 'word-online' ||
         env.startsWith('mobile') ||
         !isOfficeSSOAvailable();
}